'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux';
import {
  setBackButton,
  setIsOpenLoginSignup,
} from '@/redux/reducers/auth-reducer';
import useWindowDimensions from '@/app/hooks/useWindowSize';

/**
 * ScrollToTop Component
 *
 * A client-side component that automatically scrolls to the top of the page
 * whenever the pathname changes in the application.
 *
 * @component
 * @returns {null} This component doesn't render anything visible
 *
 * @example
 * // Usage in parent component
 * <ScrollToTop />
 */

export default function ScrollToTop() {
  const pathname = usePathname();
  const dispatch = useDispatch();
  const windowDimensions = useWindowDimensions();
  const { isOpenLoginSignup } = useSelector((state) => state.auth);

  useEffect(() => {
    // Close the login/signup modal if it's open for desktop
    window.scrollTo(0, 0);
    if (windowDimensions?.width > 1024) {
      if (isOpenLoginSignup) {
        const timeout = setTimeout(() => {
          dispatch(setIsOpenLoginSignup(false));
          dispatch(setBackButton());
        }, 101);
        return () => clearTimeout(timeout);
      }
    }
  }, [pathname]);

  return null;
}
